<template>
	<el-drawer class="drawer_uploadImg" title="优惠券详情" :visible.sync="visible" @close='close' size="1000px" :modal-append-to-body="false" :close-on-click-modal="false">
		<div style="padding-top:30px;">
			<el-row class="row">
				<el-col :span="12">
					<span class="label">优惠券名称：</span>
					<span class="value">{{curItem.coupon_name}}</span>
				</el-col>
				<el-col :span="12">
					<span class="label">核销码：</span>
					<span class="value">
						<span style="margin-right: 10px;">{{curItem._no}}</span>
						(
							<span v-if="curItem.use_status===0">不可用</span>
							<span v-if="curItem.use_status===1">未使用</span>
							<span v-if="curItem.use_status===2">已使用</span>
							<span v-if="curItem.use_status===3">已过期</span>
						)
					</span>
				</el-col>
			</el-row>
			<el-row class="row">
				<el-col :span="12">
					<span class="label">类别：</span>
					<span class="value">
						<span v-for="str in curItem.coupon_type" :key="str">
							{{str===1?'商品 ':''}}
							{{str===2?'洗美 ':''}}
							{{str===3?'病例 ':''}}
							{{str===4?'疫苗驱虫 ':''}}
							{{str===5?'医疗服务 ':''}}
							{{str===6?'寄养 ':''}}
							{{str===7?'挂号 ':''}}
							{{str===8?'活体 ':''}}
							{{str===9?'虚拟 ':''}}
							{{str===10?'订金 ':''}}
						</span>
					</span>
				</el-col>
				<el-col :span="12">
					<span class="label">满减规则：</span>
					<span class="value">
						满 {{curItem.money_top}} 可用
					</span>
				</el-col>
			</el-row>
			<el-row class="row">
				<el-col :span="12">
					<span class="label">领取时间：</span>
					<span class="value">
						<span>{{$public.FTime(curItem.receive_time,"YYYY-MM-DD")}}</span>
					</span>
				</el-col>
				<el-col :span="12">
					<span class="label">有效期：</span>
					<span class="value">
						{{$public.FTime(curItem.use_start_time,"YYYY-MM-DD")}} 到 {{$public.FTime(curItem.use_end_time,"YYYY-MM-DD")}}
					</span>
				</el-col>
			</el-row>
			<el-row class="row">
				<el-col :span="12">
					<span class="label">使用门店：</span>
					<span class="value">
						{{$dict.getShopNameById(curItem.use_shop_id)}}
					</span>
				</el-col>
				<el-col :span="12">
					<span class="label">使用时间：</span>
					<span class="value">
						{{$public.FTime(curItem.use_time,'YYYY-MM-DD HH:mm:ss')}}
					</span>
				</el-col>
			</el-row>
			<el-row class="row">
				<el-col :span="12">
					<span class="label">备注：</span>
					<span class="value">
						{{curItem.remark}}
					</span>
				</el-col>
			</el-row>
			<div style="font-size: 16px;color: #333;padding-left:20px;padding-bottom:12px;" v-if="tableData.length>0">适用于以下商品</div>
			<el-table :data="tableData" style="display: inline-block;" v-if="tableData.length>0">
				<el-table-column label="名称" >
					<template slot-scope="scope">
						<span>{{scope.row.goods_name}}</span>
					</template>
				</el-table-column>
				<el-table-column label="规格">
					<template slot-scope="scope">
						{{scope.row.sku_value}}
					</template>
				</el-table-column>
				<el-table-column label="售卖方式" >
					<template slot-scope="scope">
						{{scope.row.unit}}
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-drawer>
</template>
<script>
	export default {
		data() {
			return {
				
				visible: true,
				
				tableData:[],  // 可用商品列表

			};
		},
		props:{
			curItem:{
				default:()=>{
					return {}
				}
			},
		},
		mounted() {
			if(!this.$public.isNull(this.curItem.voucher_detail)){
				this.tableData = this.curItem.voucher_detail.product_list;
			}
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close',data:{}})
			},
		}
	};
</script>

<style scoped lang="scss">
	.drawer_uploadImg {
		::v-deep .el-drawer__header {
			margin-bottom: 10px;
		}
		
		::v-deep .el-drawer__body {
			height: calc(100% - 55px);
			overflow-y: auto;
		}
		.row{
			padding:14px 20px 14px;float: none;font-size: 20px;font-size: 12px;color:#666;border-bottom:1px solid #F2F2F2;
			.label{
				display: inline-block;width:90px;text-align: right;
			}
		}
	}
</style>
